export default __webpack_public_path__ + "static/media/Schwein-unter-Apfelbaum.24da3143.webp";